/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

export default {
  methods: {
    vFmt: function(value, n_digits) {
      // console.log('Value formatter running');
      if (value >= 0) {
        return parseFloat(value)
          .toFixed(n_digits)
          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return '';
      }
    },
  },
};
